import {Directive, ElementRef, Input, OnChanges, Renderer2, SecurityContext, SimpleChanges} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';

@Directive({
  selector: '[appHighlight]'
})
export class HighlightDirective implements OnChanges {
  @Input('appHighlight') searchTerm: string;

  set content(val: string) {
    this.renderer.setProperty(this.el.nativeElement, 'innerHTML', val);
  }

  constructor(private el: ElementRef, private sanitizer: DomSanitizer, private renderer: Renderer2) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.el?.nativeElement) {
      const text = (this.el.nativeElement as HTMLElement).textContent || '';

      if (text) {
        const searchVal = changes.searchTerm && changes.searchTerm.currentValue;
        if (!searchVal) {
          this.content = text;
        } else {
          const illegalRegExpCharters = /[*)(\[\]]/g;

          const regex = new RegExp(
            this.searchTerm.replace(illegalRegExpCharters, ''),
            'gi'
          );
          const newText = text.replace(regex, (match: string) => {
            return `<span class="highlight">${match}</span>`;
          });
          this.content = this.sanitizer.sanitize(
            SecurityContext.HTML,
            newText
          ) || '';
        }
      }
    }
  }
}
